import type { SVGProps } from 'react';

const SvgAlerts = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      d="M15.47.51a8.22 8.22 0 0 0-8.22 8.21v2.59a15.3 15.3 0 0 1-4.68 11 .76.76 0 0 0-.18.82.75.75 0 0 0 .7.47h11.79v1.49a3.2 3.2 0 1 0 1.5 0v-1.51h11.46a.74.74 0 0 0 .7-.47.76.76 0 0 0-.18-.82 15.3 15.3 0 0 1-4.68-11V8.72A8.22 8.22 0 0 0 15.47.51m1.86 27.67a1.71 1.71 0 1 1-1.7-1.71 1.7 1.7 0 0 1 1.7 1.71m8.79-6.1H4.82a16.83 16.83 0 0 0 3.93-10.77V8.72a6.72 6.72 0 0 1 13.43 0v2.59a16.78 16.78 0 0 0 3.94 10.77"
      data-name="alerts"
    />
  </svg>
);

export default SvgAlerts;
